<template>
  <div>
    <div class="small">{{$t('LoanApplicationTimeline.verificationIsNotSupported')}}</div>
    <router-link :to="{name: 'branches'}"
                 class="btn btn-sm btn-primary mt-3 mb-2 px-3">
      {{ $t('LoanApplicationTimeline.verificationFindLocations') }}
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'IdentityVerificationIsNotSupportedComponent'
}
</script>
